import * as React from "react";

const Footer = (): JSX.Element => (
  <footer>
    <em>What we see now is but a dim image in a mirror. Then we shall see face to face.</em>
  </footer>
);

export default Footer;
